/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResellerTenantProjectionResponse } from '../../models/reseller-tenant-projection-response';

export interface GetResellerTenants$Params {
  resellerId: string;
}

export function getResellerTenants(http: HttpClient, rootUrl: string, params: GetResellerTenants$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerTenantProjectionResponse>> {
  const rb = new RequestBuilder(rootUrl, getResellerTenants.PATH, 'get');
  if (params) {
    rb.path('resellerId', params.resellerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResellerTenantProjectionResponse>;
    })
  );
}

getResellerTenants.PATH = '/resellers/{resellerId}/tenants';
